/**
 * N×N symmetric correlation matrix (plan §3.3 — the 10×10 sector view).
 *
 * Built row-major and aligned with `tickers` so a caller can index
 * `values[i][j]` without a second lookup. Computed over the FULL pair set rather
 * than the upper triangle: the loop is 100 pairs on the product's largest
 * matrix, and mirroring by hand is where an off-by-one silently transposes the
 * grid — a defect that renders as a plausible matrix.
 */
import type { CorrelationMatrix, WindowKey } from '@meridian/contracts';

import { corr, type FactorSecurity } from './correlation';

export function buildCorrelationMatrix(
  rows: readonly FactorSecurity[],
  window: WindowKey,
): CorrelationMatrix {
  if (rows.length === 0) {
    throw new Error('buildCorrelationMatrix: at least one row is required');
  }
  return {
    window,
    tickers: rows.map((r) => r.ticker),
    values: rows.map((a) => rows.map((b) => corr(a, b))),
  };
}
